<script>
import Button from "@/components/atoms/button";
import Table from "@/components/molecules/table";
import dateUtil from "@/utils/date.js";

export default {
  name: "PaymentMethodMultiPay",
  components: {
    Button,
    Table
  },
  props: {
    echeancier: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ["openPopinMultiPay"],
  data() {
    return {};
  },
  computed: {
    mensualites() {
      if (!this.echeancier) {
        return [];
      }
      return this.echeancier.mensualites.map((elem) => {
        return { ...elem, date: dateUtil.formatEcheancier(elem.date) };
      });
    }
  },
  methods: {}
};
</script>

<template>
  <div class="c-payment-method-multi-pay">
    <p class="u-font-14 u-color-text-light u-mb-md">
      En choisissant ce mode de paiement, vous allez être redirigé vers le site
      sécurisé de Cetelem et souscrire au paiement en <template v-if="echeancier.code === '4FCB'">
        4 fois
      </template><template v-else>
        3 fois sans frais
      </template> par
      carte bancaire. Le prélèvement de la première échéance s'effectuera à la
      confirmation de votre commande.
      <Button
        link
        @click="$emit('openPopinMultiPay', echeancier)"
      >
        En savoir plus
      </Button>
    </p>
    <Table
      class="c-payment-method-multi-pay__table"
      size="full"
      no-bordered
    >
      <thead>
        <tr>
          <th
            align="left"
            scope="col"
          >
            Échéancier
          </th>
          <th
            align="left"
            scope="col"
          >
            Montant à payer
          </th>
        </tr>
      </thead>
      <tbody>
        <template
          v-for="(mensualite, index) in mensualites"
          :key="mensualite.date"
        >
          <tr>
            <th
              scope="row"
              align="left"
            >
              {{ index === 0 ? "1er" : `${index + 1}ème` }} prélèvement le
              {{ mensualite.date }}
            </th>
            <td align="left">
              <span class="u-font-700">
                {{ formatPrix(mensualite.montant) }}&nbsp;€
              </span>
              <template v-if="index === 0 && echeancier.frais">
                <br />
                <span class="u-font-12">
                  dont {{ formatPrix(echeancier.frais) }} € de frais de dossier
                </span>
              </template>
            </td>
          </tr>
        </template>
      </tbody>
    </Table>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/payment-method-multi-pay.scss";
@import "@/assets/styles/components/table.scss";
</style>
